import { type RouteLocationNormalized } from 'vue-router'
import { useDark } from '@vueuse/core'
import { clearDialogsAndToasts } from '@shared/utils/misc/dialogs'

useDark({
  storageKey: 'YM.theme',
  valueDark: 'dark',
  valueLight: 'light',
  initialValue: 'auto'
})

const logger = createLogger('ym:auth:middleware')

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  if (process.client) {
    // Update the dialog visibility
    clearDialogsAndToasts()
  }
})
